import React from 'react';
import './AnalitosPlantillas.scss';

export default () => (
  <React.Fragment>
    <h2 className={'content-block'}>AnalitosPlantillas</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        Put your content here
      </div>
    </div>
  </React.Fragment>
);
